/**
 * Form validation utilities
 */

/**
 * Email validation according to RFC 5322
 * @param {string} email
 * @param {function} t - Translation function
 * @returns {string|null} Error message or null
 */
export const validateEmail = (email, t) => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (!email || email.trim() === '') {
    return t('validation.emailRequired');
  }

  if (email.length > 254) {
    return t('validation.emailTooLong');
  }

  if (!emailRegex.test(email)) {
    return t('validation.emailInvalid');
  }

  const parts = email.split('@');
  if (parts.length !== 2) {
    return t('validation.emailInvalid');
  }

  const domain = parts[1];
  if (!domain.includes('.')) {
    return t('validation.emailNoDomain');
  }

  const tld = domain.split('.').pop();
  if (tld.length < 2) {
    return t('validation.emailInvalidDomain');
  }

  return null;
};

/**
 * Password validation
 * @param {string} password
 * @param {function} t - Translation function
 * @returns {string|null} Error message or null
 */
export const validatePassword = (password, t) => {
  if (!password) {
    return t('validation.passwordRequired');
  }

  if (password.length < 6) {
    return t('validation.passwordMinLength');
  }

  return null;
};

/**
 * Password match validation
 * @param {string} password
 * @param {string} confirmPassword
 * @param {function} t - Translation function
 * @returns {string|null} Error message or null
 */
export const validatePasswordMatch = (password, confirmPassword, t) => {
  if (password !== confirmPassword) {
    return t('validation.passwordsNotMatch');
  }
  return null;
};
